import React from "react"
import StringHelper from "./string_helper"
import UniqId from "uniqid"

export default class AddressHelper {
  constructor(lang, states, property) {
    this.lang = lang
    this.states = states
    this.property = property
  }

  static address(
    prefecture,
    city,
    streetAddress,
    aptName,
    lang,
    countryCode,
    country = ""
  ) {
    if ((countryCode == "jp" && lang == "ja") || lang == 'zh-TW') {
      return (
        <span className="notranslate">
          {StringHelper.getPreferredLanguageString(prefecture, lang)}
          {StringHelper.getPreferredLanguageString(city, lang)}
          {StringHelper.getPreferredLanguageString(streetAddress, lang)}
          {StringHelper.getPreferredLanguageString(aptName, lang)}
        </span>
      )
    } else {
      // always english other than JP properties
      const aptNameEn = StringHelper.getPreferredLanguageString(aptName, "en")
      const prefectureEn = StringHelper.getPreferredLanguageString(prefecture, "en")

      return (
        <span className="notranslate">
          {aptNameEn && `${aptNameEn}, `}
          {`${StringHelper.getPreferredLanguageString(streetAddress, "en")}, `}
          {`${StringHelper.getPreferredLanguageString(city, "en")}, `}
          {prefectureEn && `${prefectureEn}, `}
          {country}
        </span>
      )
    }
  }

  simpleAddress() {
    if (this.states.length == []) return
    if (this.property.country_code == "jp" && this.lang == "ja") {
      return `${this.state}${this.city}${this.streetAddress}${this.aptName}`
    } else {
      return `${this.aptName} ${this.streetAddress} ${this.city} ${this.state}`
    }
  }

  stateCity() {
    if (this.states.length == []) return
    if (this.property.country_code == "jp" && this.lang == "ja") {
      return `${this.state}${this.city}`
    } else {
      return `${this.city} ${this.state}`
    }
  }

  get state() {
    return this.states[this.property.prefecture]
  }

  get aptName() {
    return this.property.apt_name
  }

  get streetAddress() {
    return this.property.street_address
  }

  get city() {
    return this.property.city
  }
}
